import { productionHostnames } from 'constants/hostnames'

export function isProd() {
  const hostname = window.location.hostname
  return productionHostnames.includes(hostname)
}
